import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { LogOut, Ghost, Sun, Moon } from "lucide-react";

export const HeaderNav = () => {
  const { user, logout } = useAuth();
  const { theme, toggleTheme, brand } = useSettings();
  const navigate = useNavigate();

  const home = () => {
    if (!user) return "/";
    if (user.role === "super_admin") return "/admin";
    if (user.role === "org_admin") return "/org";
    return "/dashboard";
  };

  const productName = brand?.product_name || "Caesar's Ghost";
  const identity = user?.first_name || user?.name?.split(" ")[0] || user?.role?.replace("_", " ");
  // Theme-aware logo: light background → dark/black logo; dark background → light/white logo.
  const headerLogo = theme === "light"
    ? (brand?.logo_light || brand?.logo_primary)
    : (brand?.logo_dark || brand?.logo_primary);

  return (
    <header className="cg-glass sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to={home()} data-testid="brand-home-link" className="flex items-center gap-2.5 group">
          {headerLogo ? (
            <img src={headerLogo} alt={productName} className="h-11 w-auto max-w-[190px] object-contain" />
          ) : (
            <>
              <Ghost className="w-5 h-5 text-brass transition-transform group-hover:-translate-y-0.5" />
              <span className="font-serif text-xl tracking-tight text-[#F3F4F6]">{productName}</span>
            </>
          )}
        </Link>
        <div className="flex items-center gap-4">
          <button
            data-testid="theme-toggle"
            onClick={toggleTheme}
            aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            className="text-[#9CA3AF] hover:text-brass cg-scale-btn p-1.5"
          >
            {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </button>
          {user ? (
            <>
              <span className="hidden sm:block cg-eyebrow" data-testid="nav-identity">{identity}</span>
              <button
                data-testid="logout-button"
                onClick={async () => { await logout(); navigate("/"); }}
                className="flex items-center gap-2 text-sm text-[#9CA3AF] hover:text-brass cg-scale-btn"
              >
                <LogOut className="w-4 h-4" /> Sign out
              </button>
            </>
          ) : (
            <Link to="/login" data-testid="nav-login-link" className="text-sm cg-link">Sign in</Link>
          )}
        </div>
      </div>
    </header>
  );
};
